<template>
  <div class="mt-2 h-10 text-left flex gap-2 items-center box-border w-full">
    <div
      class="mt-0 h-full xs:w-3/12 sm:w-7/12 md:w-10/12 w-12/12 border border-gray-500 rounded-lg text-xs md:text-sm flex flex-row gap-2 items-center"
    >
      <img
        src="@/assets/icons/file-document.svg"
        alt="icono blanco de documento"
        class="h-5 my-auto mr-2 pl-5"
      />
      <p class="text-xs text-gray-500 truncate" :title="file_name">
        {{ file_name }}
      </p>
    </div>
    <button
      v-if="can_be_downloaded"
      class="h-full sm:w-22 lg:w-44 w-24 rounded-md h-10 sm:mx-auto mx-0 sm:px-5 mt-auto hover:bg-blue-500 general-color-button flex flex-row justify-center items-center"
      @click="onDownload(value)"
    >
      <img
        src="@/assets/icons/download.svg"
        alt="icono de descarga"
        class="h-5 my-auto sm:mr-2"
      />
      <div v-if="loading" class="flex justify-center items-center">
        <a-spin>
          <a-icon
            slot="indicator"
            type="loading"
            style="font-size: 16px"
            spin
          />
        </a-spin>
      </div>
      <span class="text-xs text-white hidden sm:block">{{ legend }}</span>
    </button>
    <a-popconfirm
      v-if="can_be_downloaded && can_delete_file"
      title="¿Estás seguro de que deseas eliminar este anexo?"
      ok-text="Sí"
      cancel-text="No"
      @confirm="deleteRecord"
    >
      <a-button type="link" class="m-0 p-0">
        <a-icon
          type="delete"
          theme="twoTone"
          twoToneColor="#F73C13"
          :style="{ fontSize: '20px', color: '#F73C13' }"
        />
      </a-button>
    </a-popconfirm>
  </div>
</template>

<script>
import complaintsEmisorServicesImplementation from "@/feature/dashboard/complaints_emisor/data/services/complaints_emisor_services_impl";
import ErrorMessaje from "@/core/error/error_messaje";
export default {
  props: {
    id: {
      default: "",
    },
    label: {
      type: String,
      default: "Anexos",
    },
    value: {
      default: null,
    },
    file_name: {
      type: String,
      default: "<not name>",
    },
    can_be_downloaded: {
      type: Boolean,
      default: true,
    },
    can_delete_file: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      feedback: "",
      legend: "Descargar",
    };
  },  
  methods: {
    deleteRecord() {
      if (this.can_delete_file) {
        this.$emit("attachment-2-delete", this.$vnode.key, this.value);
      }
    },
    async onDownload(value) {       
      try {
        const response =
          await complaintsEmisorServicesImplementation.downloadComplaintEmisoresAnnexes(
            value.id
          );

        if (response.isSuccess) {           
          const url_download = response.data.url_file;
          let a = document.createElement("a");
          a.href = url_download;
          a.target = "_blank";
          a.download = value;
          a.click();
        } else {
          this.showToast("error", ErrorMessaje.generalError);
        }
      } catch (error) {
        this.showToast("error", ErrorMessaje.internalServerError);
      } 
    },
    showToast(result = "info", msg) {
      this.$notification[result]({
        message: "Resultado",
        description: msg,
        onClick: () => {},
      });
    },
  },
  computed: {},
};
</script>
